import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TelegramService } from '../../../pages/page-telegram/telegram.service';
import { Lead, LeadTask } from '../../../types/lead.type';
import { AppService } from '../../../services/app.service';
import { InterfaceService } from '../../../services/interface.service';
import { DcService } from '../../../services/dc.service';
import { Message } from '../../../types/all.type';
import { Preset } from '../../../types/preset.type';
import { FormArray, FormControl, FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { SubscribeLeadResult } from '../../../types/lead_subscribe.type';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadsService {
  load$: Subject<boolean> = new Subject();
  filterWork = 0;
  createTaskFromPreset$: Subject<Preset> = new Subject();
  leadTasks$: BehaviorSubject<LeadTask[]> = new BehaviorSubject([]);
  editLeadTask$: BehaviorSubject<LeadTask | void> = new BehaviorSubject(undefined);
  reloadScanTasks$: ReplaySubject<void> = new ReplaySubject();
  loadLeads$: ReplaySubject<void> = new ReplaySubject();
  taskForm: FormGroup<{
    name: FormControl<string>;
    min_scope: FormControl<number>;
    text_variations: FormArray<any>;
    all_chats: FormControl<boolean>;
    history_scanned: FormControl<boolean>;
    chats: FormArray<any>;
    key_words: FormControl<string>;
    negative_key_words: FormControl<string>;
    pause: FormControl<boolean>;
    // Auto message
    auto_message: FormControl<string>;
    auto_message_active: FormControl<boolean>;
    auto_message_min_scope: FormControl<number>;
    auto_message_is_move_to: FormControl<boolean>;
    // Reply
    replay_type: FormControl<string>;
    no_create_lead: FormControl<boolean>;

  }>;
  public urlApi: any = environment.leads;

  constructor(
    private dcService: DcService,
    public interfaceService: InterfaceService,
    private appService: AppService,
    private http: HttpClient,
    private fb: NonNullableFormBuilder
  ) {
    this.taskForm = this.fb.group({
      name: ['', []],
      min_scope: [52, [Validators.required, Validators.min(45)]],
      text_variations: this.fb.array([]),
      all_chats: [true, []],
      history_scanned: [false, []],
      chats: this.fb.array([]),
      key_words: ['', [Validators.required]],
      negative_key_words: ['', []],
      pause: [false, []],
      // Auto message
      auto_message: ['', []],
      auto_message_active: [true, []],
      auto_message_min_scope: [55, []],
      auto_message_is_move_to: [true, []],
      // Reply
      replay_type: ['private', []],
      no_create_lead: [false, []]
    });
  }

  getLeads(accountId: number, taskId: number = 0): Observable<Lead[]> {
    let uri = `${this.urlApi}/api/leads?account_id=${accountId}`;
    if (taskId && taskId > 0) {
      uri += `&task_id=${taskId}`;
    }
    return (this.http.get(uri, {}) as any);
  }

  getPresets(accountId: number): Observable<Preset[]> {
    return (this.http.get(`${this.urlApi}/api/presets?account_id=${accountId}`, {}) as any);
  }

  subscribePreset(accountId: number, presetId: number): Observable<SubscribeLeadResult> {
    return (this.http.post(`${this.urlApi}/api/presets/subscribe`, {
      account_id: accountId,
      preset_id: presetId
    }) as any);
  }

  getLeadsTasks(accountId: number): Observable<LeadTask[]> {
    return (this.http.get(`${this.urlApi}/api/leads/tasks?account_id=${accountId}`, {}) as any);
  }

  updateLead(data: Lead): Observable<Lead> {
    return (this.http.put(`${this.urlApi}/api/leads`, {
      id: data.id,
      column: data.Category,
      viewed: true
    }) as any);
  }

  deleteLead(id: number, ignore: boolean = false): Observable<{ success: boolean }> {
    return (this.http.delete(`${this.urlApi}/api/leads/${id}?ignore=${ignore}`) as any);
  }
  clearColumn(accountId: number, column: string): Observable<{ success: boolean }> {
    return (this.http.delete(`${this.urlApi}/api/leads/column/${accountId}/${column}`) as any);
  }

  createLeadTask(data: Lead): Observable<Lead> {
    return (this.http.post(`${this.urlApi}/api/leads/tasks`, data) as any);
  }

  updateLeadTask(data: Lead): Observable<Lead> {
    return (this.http.put(`${this.urlApi}/api/leads/tasks`, data) as any);
  }
  pauseLeadTask(id: number, pause = false): Observable<Lead> {
    return (this.http.put(`${this.urlApi}/api/leads/tasks/${id}/pause`, {pause}) as any);
  }



  deleteLeadTask(id: number): Observable<{ success: boolean }> {
    return (this.http.delete(`${this.urlApi}/api/leads/tasks/${id}`) as any);
  }


  deletePreset(id: number, accountId: number): Observable<{ success: boolean }> {
    return (this.http.delete(`${this.urlApi}/api/presets/${id}?account_id=${accountId}`) as any);
  }


  openMessage(data: Lead, Service: TelegramService) {
    // this.router.navigateByUrl('/ui');
    const chatId = data.chat?.chat || data.message.message.chat_id;
    Service.getDetailInfo(chatId, false).subscribe((res) => {
      this.appService.openChat(res.chat, Service, true);
      setTimeout(() => {
        Service.editMessage = false;
        Service.forwardMessage = false;
        const message: Message = {...data.message.message};
        message.out = false;
        Service.replyMessage = message;
        this.interfaceService.focusTextArea$.next(true);
        this.dcService.detectChanges$.next('chat-show');
      }, 500);
    }, error => {
      this.openMessageInTelegram(data);
    });
  }

  openUserChat(data: Lead, Service: TelegramService) {
    const from_user = data.message?.message?.from_user;
    const chatId = from_user?.username || from_user?.id;
    Service.getDetailInfo(chatId, false).subscribe((res) => {
      this.appService.openChat(res.chat, Service, true);
      setTimeout(() => {
        Service.editMessage = false;
        Service.replyMessage = false;
        const message: Message = {...data.message.message};
        message.out = false;
        Service.forwardMessage = message;
        this.interfaceService.focusTextArea$.next(true);
        this.dcService.detectChanges$.next('chat-show');
      }, 500);
    }, error => {
      this.openUserChatInTelegram(data);
    });
  }

  openUserChatInTelegram(data: Lead) {
    console.log('openUserChat', data.message?.message);
    if (data.message?.message?.from_user?.username) {
      window.open(`https://t.me/${data.message?.message?.from_user?.username}`);
    }
  }

  openMessageInTelegram(data: Lead): void {
    const chatId = String(data.message?.message?.chat_id).replace('-100', '');
    if (this.hasPrivate(data)) {
      window.open(`https://t.me/${data?.chat?.chat}/${data.message?.message?.id}`);
    } else {
      window.open(`https://t.me/c/${chatId}/${data.message?.message?.id}`);
    }
  }

  openMessageChat(data: Lead) {
    const chatId = String(data.message?.message?.chat_id).replace('-100', '');
    if (this.hasChat(data)) {
      window.open(`https://t.me/${data?.chat?.chat}/${data.message?.message?.id}`);
    } else {
      window.open(`https://t.me/c/${chatId}/${data.message?.message?.id}`);
    }
  }

  hasPrivate(data: Lead): boolean {
    return !!data.message?.message?.from_user?.username;
  }

  hasChat(data: Lead): boolean {
    return !!data?.chat?.chat;
  }


}

